interface Props {
  [key: string]: any
}

function HomArrowLeftIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 32 22" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ?? ''}
        d="M0.377646 9.62446L9.62456 0.377551C10.128 -0.125847 10.9435 -0.125847 11.4469 0.377551L13.2802 2.21085C13.7836 2.71425 13.7836 3.52983 13.2802 4.03323L4.03255 13.2809C3.52915 13.7843 2.71357 13.7843 2.21017 13.2809L0.376866 11.4476C-0.125752 10.9442 -0.125752 10.1279 0.377646 9.62446Z"
        fill="#6F46A5"
      />
      <path
        className={pathClassName ?? ''}
        d="M30.8296 7.80519L2.34277 7.80519L4.09881 14.0489L30.8296 14.0489C31.4759 14.0489 32.0003 13.5244 32.0003 12.8782V8.97589C32.0003 8.32966 31.4759 7.80519 30.8296 7.80519Z"
        fill="#7D38D6"
      />
      <path
        className={pathClassName ?? ''}
        d="M0.377646 11.4488L10.4058 21.4761C10.9092 21.9795 11.7248 21.9795 12.2282 21.4761L14.0615 19.6428C14.5649 19.1394 14.5649 18.3238 14.0615 17.8205L4.04582 7.80556H2.19768L0.376866 9.62638C-0.125752 10.129 -0.125752 10.9454 0.377646 11.4488Z"
        fill="#7D38D6"
      />
    </svg>
  )
}

export default HomArrowLeftIcon
